"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDeviceType = void 0;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
const getDeviceType = () => new web_ui_framework_1.DeviceChecker().getCurrentDeviceByUserAgent();
exports.getDeviceType = getDeviceType;
//# sourceMappingURL=device.utility.js.map